import { render, staticRenderFns } from "./LoadDocuments.vue?vue&type=template&id=472d0396"
import script from "./LoadDocuments.vue?vue&type=script&lang=js"
export * from "./LoadDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports